// ...existing code...
import React from 'react';

import { DialogoCreateEdit } from '../../Components/modulo-gerencial-dialogos';
import {
  TextInput,
  SwitchInput,
} from '../../Components/modulo-gerencial-formularios';

const initialValues = {
  descricao: '',
  permissao_gerencial: false,
  permissao_fc: false,
  permissao_ponto_digital: false,
};

const validadores = {
  descricao: (value, values, config) => {
    if (!value.trim()) return '';
    if (value.trim().length < 5) return 'Não pode ser menor que 5 caracteres';
    if (value.trim().length > 50) return 'Não pode ser maior que 50 caracteres';
    return '';
  },
  permissao_gerencial: () => '',
  permissao_fc: () => '',
  permissao_ponto_digital: () => '',
};

const transformGetDados = (dados, config) => ({
  descricao: dados.descricao ? dados.descricao.trim() : '',
  permissao_gerencial: dados.permissao_gerencial ? true : false,
  permissao_fc: dados.permissao_fc ? true : false,
  permissao_ponto_digital: dados.permissao_ponto_digital ? true : false,
});

const transformSalvar = (dados, config) => ({
  descricao: dados.descricao.trim(),
  permissao_gerencial: dados.permissao_gerencial,
  permissao_fc: dados.permissao_fc,
  permissao_ponto_digital: dados.permissao_ponto_digital,
});

function Form() {
  return (
    <div style={{}}>
      <div>
        <label style={{ display: 'block', marginBottom: 6, fontWeight: 600 }}>
          Descrição
        </label>
        <TextInput
          name="descricao"
          fullWidth
          placeholder="Ex.: PDV-01 - Caixa 1"
          autoFocus
        />
      </div>

      <div
        style={{
          display: 'flex',
          gap: 12,
          alignItems: 'center',
          flexWrap: 'wrap',
        }}
      >
        <div style={{ width: '100%' }}>
          <label style={{ display: 'block', marginBottom: 6, fontWeight: 600 }}>
            Permissões
          </label>
          <div
            style={{
              display: 'flex',
              gap: 12,
              justifyContent: 'space-between',
              width: '100%',
            }}
          >
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <SwitchInput name="permissao_gerencial" label="" />
              <span style={{ fontSize: 12, color: '#666' }}>
                Acesso ao módulo gerencial
              </span>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <SwitchInput name="permissao_fc" label="" />
              <span style={{ fontSize: 12, color: '#666' }}>Acesso ao FC</span>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <SwitchInput name="permissao_ponto_digital" label="" />
              <span style={{ fontSize: 12, color: '#666' }}>
                Permite uso no Ponto Digital
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const Dialogo = ({ onClose, open, id, isDialogoConfirmacaoActions }) => (
  <DialogoCreateEdit
    open={open}
    id={id}
    initialValues={initialValues}
    validators={validadores}
    resource="pdv-machines"
    titleCreate="Computador PDV"
    titleUpdate="Computador PDV"
    nested={[]}
    onClose={onClose}
    transformGetDados={transformGetDados}
    transformSalvar={transformSalvar}
    isCloseTitle
    isDialogoConfirmacaoActions={isDialogoConfirmacaoActions}
  >
    <Form />
  </DialogoCreateEdit>
);

export default Dialogo;
//
